const defaultApiBaseUrl = "https://localhost:44304/api/";

function trimTrailingSlash(value) {
  return String(value || "").replace(/\/+$/, "");
}

function ensureTrailingSlash(value) {
  const trimmed = trimTrailingSlash(value);
  return trimmed ? `${trimmed}/` : "";
}

const runtimeConfig = window.__APP_CONFIG__ || {};
const configuredApiBaseUrl = runtimeConfig.API_BASE_URL || defaultApiBaseUrl;

export const API_BASE_URL = ensureTrailingSlash(configuredApiBaseUrl);
export const API_ORIGIN_URL = trimTrailingSlash(API_BASE_URL.replace(/\/api\/?$/i, ""));

